



























































































import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBackward, faPause, faPlay } from '@fortawesome/free-solid-svg-icons'
import { changeSpeed } from '../composables/player/useChangeSpeed'
import {
  defineComponent,
  onMounted,
  ref,
  toRefs,
  watch
} from '@vue/composition-api'
import { useActions } from '../store/useActions'
import { scrollToWordByClassName } from '../composables/scrollToWordByClassName'
import { Word } from '../models/word'

export default defineComponent({
  name: 'AudioPlayer',
  components: { FontAwesomeIcon },
  props: {
    audioUrl: {
      type: String,
      default: 'conversation-11255.mp3'
    },
    words: {
      type: Array as () => Word[],
      required: true,
      default: () => []
    }
  },
  setup(props, { emit, root }) {
    const { words } = toRefs(props)
    const player = ref<HTMLAudioElement | null>(null)
    const inputPlayer = ref<HTMLInputElement | null>(null)
    const { speed, nextSpeed } = changeSpeed()
    const audioDuration = ref<number>(100)
    const playbackTime = ref<number>(0)
    const audioLoaded = ref<boolean>(false)
    const isPlaying = ref<boolean>(false)

    const { setPlayerTime, setPlayerStatus } = useActions({
      setPlayerTime: 'conversation/setPlayerTime',
      setPlayerStatus: 'conversation/setPlayerStatus'
    })

    onMounted(() => {
      document.documentElement.classList.add('js')
    })

    function playbackListener() {
      if (!player.value) {
        return
      }
      if (!inputPlayer.value) {
        return
      }
      playbackTime.value = player.value.currentTime
      inputPlayer.value.style.setProperty(
        '--val',
        String(playbackTime.value + 0.5)
      )

      emit('time-changed', player.value.currentTime)
      setPlayerTime(player.value.currentTime)
    }

    function changePlayingSpeed() {
      nextSpeed()
      if (!player.value) {
        return
      }
      player.value.playbackRate = speed.value
    }

    function initSlider() {
      if (!player.value) {
        return
      }
      audioDuration.value = Math.round(player.value.duration)
    }

    function canPlay() {
      audioLoaded.value = true
      if (!inputPlayer.value) {
        return
      }
      inputPlayer.value.style.setProperty('--val', String(playbackTime.value))
      inputPlayer.value.style.setProperty('--max', String(audioDuration.value))
      inputPlayer.value.style.setProperty(
        '--min',
        String(parseInt(inputPlayer.value.min) + 1)
      )
    }

    function onEnd() {
      isPlaying.value = false
    }

    function onPause() {
      isPlaying.value = false
    }

    function toggleAudio() {
      if (!player.value) {
        return
      }

      if (player.value.paused) {
        player.value.play()
        isPlaying.value = true
        // const word = words.value.find(
        //     v => v.start <= player.value!.currentTime && v.end >= player.value!.currentTime
        // );

        emit('toggle', true)
        setPlayerStatus(true)
      } else {
        player.value.pause()
        isPlaying.value = false
        emit('toggle', false)
        setPlayerStatus(false)
      }
    }
    function convertTime(seconds: number) {
      const format = (val: number) => `0${Math.floor(val)}`.slice(-2)
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const remainingSeconds = seconds % 60

      if (hours > 0) {
        return [hours, minutes, remainingSeconds].map(format).join(':')
      } else {
        return [minutes, remainingSeconds].map(format).join(':')
      }
    }

    function totalTime() {
      if (player.value) {
        const seconds = player.value.duration
        return convertTime(seconds)
      } else {
        return '00:00'
      }
    }

    function elapsedTime() {
      if (player.value) {
        const seconds = player.value.currentTime
        return convertTime(seconds)
      } else {
        return '00:00'
      }
    }

    function rewind(isForward: boolean) {
      isForward ? (playbackTime.value -= 5) : (playbackTime.value += 5)
    }

    function setPlaybackTime(time: number, play = false) {
      if (!player.value) {
        return
      }
      player.value.currentTime = time
      playbackTime.value = time
      if (play) {
        player.value.play()
        isPlaying.value = true
        emit('toggle', true)
        setPlayerStatus(true)
      }
    }

    watch(playbackTime, () => {
      if (!player.value) {
        return
      }
      const diff = Math.abs(playbackTime.value - player.value.currentTime)
      if (diff > 0.01) {
        player.value.currentTime = playbackTime.value
        emit('time-changed', player.value.currentTime)
        setPlayerTime(player.value.currentTime)
      }
    })

    function scrollToSpelledWord() {
      // root.$nextTick(() => {
      scrollToWordByClassName('current')
      // })
    }

    return {
      scrollToSpelledWord,
      changePlayingSpeed,
      playbackListener,
      setPlaybackTime,
      elapsedTime,
      toggleAudio,
      initSlider,
      totalTime,
      canPlay,
      onPause,
      rewind,
      onEnd,
      speed,
      player,
      inputPlayer,
      isPlaying,
      audioLoaded,
      playbackTime,
      audioDuration,
      playIcon: faPlay,
      pauseIcon: faPause,
      rewindIcon: faBackward
    }
  }
  // data() {
  //     return {
  //         // playbackTime: 0,
  //         playIcon: faPlay,
  //         pauseIcon: faPause,
  //         rewindIcon: faBackward
  //         // audioDuration: 100,
  //         // audioLoaded: false,
  //         // isPlaying: false
  //     }
  // },
  // methods: {
  // rewind(isForward) {
  //     isForward ? (this.playbackTime -= 5) : (this.playbackTime += 5)
  // },
  // test() {
  //     const audio = this.$refs.player
  //     if (audio) {
  //         const seconds = audio.currentTime
  //         console.log(seconds, this.playbackTime)
  //     }
  // }
  //Set the range slider max value equal to audio duration
  // initSlider() {
  //     const audio = this.$refs.player
  //     if (audio) {
  //         this.audioDuration = Math.round(audio.duration)
  //     }
  // },
  //Convert audio current time from seconds to min:sec display
  // convertTime(seconds) {
  //     const format = val => `0${Math.floor(val)}`.slice(-2)
  //     // const hours = seconds / 3600
  //     const minutes = (seconds % 3600) / 60
  //     return [minutes, seconds % 60].map(format).join(':')
  // },
  // //Show the total duration of audio file
  // totalTime() {
  //     const audio = this.$refs.player
  //     if (audio) {
  //         const seconds = audio.duration
  //         return this.convertTime(seconds)
  //     } else {
  //         return '00:00'
  //     }
  // },
  // //Display the audio time elapsed so far
  // elapsedTime() {
  //     const audio = this.$refs.player
  //     if (audio) {
  //         const seconds = audio.currentTime
  //         return this.convertTime(seconds)
  //     } else {
  //         return '00:00'
  //     }
  // },
  //Playback listener function runs every 100ms while audio is playing
  // playbackListener() {
  //     const audio = this.$refs.player
  //     //Sync local 'playbackTime' var to audio.currentTime and update global state
  //     this.playbackTime = audio.currentTime
  //
  //     // console.log('update: ' + audio.currentTime)
  //     this.$emit('time-changed', audio.currentTime)
  //     //Add listeners for audio pause and audio end events
  //     // audio.addEventListener('ended', this.endListener)
  //     // audio.addEventListener('pause', this.pauseListener)
  // },
  //Function to run when audio is paused by user
  // pauseListener() {
  // this.isPlaying = false
  // this.listenerActive = false
  // this.cleanupListeners()
  // },
  //Function to run when audio play reaches the end of file
  // endListener() {
  //     this.isPlaying = false
  // this.listenerActive = false
  // this.cleanupListeners()
  // },
  //Remove listeners after audio play stops
  // cleanupListeners() {
  //     const audio = this.$refs.player
  //     audio.removeEventListener('timeupdate', this.playbackListener)
  //     audio.removeEventListener('ended', this.endListener)
  //     audio.removeEventListener('pause', this.pauseListener)
  //     //console.log("All cleaned up!");
  // },
  // toggleAudio() {
  //     const audio = this.$refs.player
  //     //var audio = document.getElementById("audio-player");
  //     if (audio.paused) {
  //         audio.play()
  //         this.isPlaying = true
  //         this.$emit('toggle', true)
  //     } else {
  //         audio.pause()
  //         this.isPlaying = false
  //         this.$emit('toggle', false)
  //     }
  // },
  // play() {
  //     const audio = this.$refs.player
  //     audio.play()
  //     this.isPlaying = true
  //     this.$emit('toggle', true)
  // },
  // setPlaybackTime(time, play = false) {
  //     const audio = this.$refs.player
  //     audio.currentTime = time
  //     this.playbackTime = time
  //     if (play) {
  //         this.play()
  //     }
  // }
  // }
  // mounted: function() {
  //     // nextTick code will run only after the entire view has been rendered
  //     this.$nextTick(function() {
  //         // const audio = this.$refs.player
  //         //Wait for audio to load, then run initSlider() to get audio duration and set the max value of our slider
  //         // "loademetadata" Event https://www.w3schools.com/tags/av_event_loadedmetadata.asp
  //         // audio.addEventListener(
  //         //     'loadedmetadata',
  //         //     function(e) {
  //         //         console.log(audio.duration, 'tut ne titu((')
  //         //         this.initSlider()
  //         //     }.bind(this)
  //         // )
  //         // "canplay" HTML Event lets us know audio is ready for play https://www.w3schools.com/tags/av_event_canplay.asp
  //         // audio.addEventListener(
  //         //     'canplay',
  //         //     function(e) {
  //         //         this.audioLoaded = true
  //         //     }.bind(this)
  //         // )
  //         //Wait for audio to begin play, then start playback listener function
  //         // this.$watch('isPlaying', function() {
  //         //     if (!this.isPlaying) {
  //         //         return
  //         //     }
  //         //
  //         //     const audio = this.$refs.player
  //         //     this.initSlider()
  //         //     //console.log("Audio playback started.");
  //         //     //prevent starting multiple listeners at the same time
  //         //     if (!this.listenerActive) {
  //         //         this.listenerActive = true
  //         //         //for a more consistent timeupdate, include freqtimeupdate.js and replace both instances of 'timeupdate' with 'freqtimeupdate'
  //         //         audio.addEventListener('timeupdate', this.playbackListener)
  //         //     }
  //         // })
  //         //Update current audio position when user drags progress slider
  //         this.$watch('playbackTime', function() {
  //             const audio = this.$refs.player
  //             const diff = Math.abs(this.playbackTime - audio.currentTime)
  //             //Throttle synchronization to prevent infinite loop between playback listener and this watcher
  //             if (diff > 0.01) {
  //                 audio.currentTime = this.playbackTime
  //                 console.log('here need')
  //                 this.$emit('time-changed', parseInt(this.playbackTime))
  //             }
  //         })
  //     })
  // }
})
